import { theme } from "@/libs/@mantine/core/theme";
import { queryClient } from "@/libs/@tanstack/react-query";
import { MantineProvider } from "@mantine/core";
import { ModalsProvider } from "@mantine/modals";
import { Notifications } from "@mantine/notifications";
import { QueryClientProvider } from "@tanstack/react-query";
import type { FC, PropsWithChildren } from "react";

export const AppProvider: FC<PropsWithChildren> = ({ children }) => {
	return (
		<MantineProvider theme={theme}>
			<Notifications position="bottom-left" />
			<ModalsProvider>
				<QueryClientProvider client={queryClient}>
					{children}
				</QueryClientProvider>
			</ModalsProvider>
		</MantineProvider>
	);
};
